import React, { useState, useEffect, useContext } from "react";
import { Table, notification, Select, DatePicker, Input } from "antd";
import { css } from "emotion";
import Cookies from "js-cookie";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import LayoutOperationJobHistory from "../../components/LayoutOperationJobHistory";
import ServiceApi from "../../services/ServiceApi";
import { authUserContext } from "../../contexts/authContext";
import { useLocation } from "react-router-dom";

const { Option } = Select;
const { RangePicker } = DatePicker;

const TableCss = css({
  "& table": { fontSize: "18px", fontFamily: "ThaiSansR" },
});

const columns = [
  {
    title: "Opened",
    dataIndex: "opened",
    key: "opened",
    width: 120,
    fixed: "left",
    sorter: (a, b) => {
      return null;
    },
    // render: (text) => (
    //   <div className="d-flex justify-content-center">
    //     <span className="font-thai-r fs-18">{text}</span>
    //   </div>
    // ),
  },
  {
    title: "Job No",
    dataIndex: "",
    key: "",
    width: 120,
    fixed: "left",
    sorter: (a, b) => {
      return a.job_no - b.job_no;
    },
    render: (item) => (
      <p
        // href={null}
        className="font-thai-r c-blue text-underline"
        // onClick={() => btnFunction.setLinktoController(item.job_id)}
      >
        {item.job_no}
      </p>
    ),
  },
  {
    title: "S/O ID",
    dataIndex: "so_id",
    key: "so_id",
    width: 160,
    sorter: (a, b) => {
      return a.so_id.length - b.so_id.length;
    },
    render: (text) => (
      <div className="d-flex justify-content-center">
        <span className="font-thai-r fs-18">{text}</span>
      </div>
    ),
  },
  {
    title: "SAP ID",
    dataIndex: "sap_id",
    key: "sap_id",
    width: 100,
    sorter: (a, b) => {
      return a.sap_id - b.sap_id;
    },
  },
  {
    title: "Site ID",
    dataIndex: "job_site_code",
    key: "job_site_code",
    width: 120,
    sorter: (a, b) => {
      return null;
    },
  },
  {
    title: "Site Name",
    dataIndex: "job_site_name",
    key: "job_site_name",
    width: 160,
    sorter: (a, b) => {
      return null;
    },
  },
  {
    title: "Center",
    dataIndex: "area_code",
    key: "area_code",
    width: 90,
    sorter: (a, b) => {
      return a.area_code.length - b.area_code.length;
    },
    render: (text) => (
      <div className="d-flex justify-content-center">
        <span className="font-thai-r fs-18">{text}</span>
      </div>
    ),
  },
  {
    title: "Open Time",
    dataIndex: "first_Start_date",
    key: "first_Start_date",
    width: 140,
    // sorter: (a, b) => {
    //   const st = moment(a.first_Start_date);
    //   const en = moment(b.first_Start_date);
    //   return st.diff(en);
    // },
    render: (Startdate) => {
      if (Startdate === null) {
        return <span>&nbsp;</span>;
      } else {
        return (
          <span>
            {/* <FormatDateTime text={Startdate}></FormatDateTime> */}
          </span>
        );
      }
    },
  },
  {
    title: "Restored Time",
    dataIndex: "restoredTime",
    key: "restoredTime",
    width: 140,
    // sorter: (a, b) => {
    //   const st = moment(a.restoredTime);
    //   const en = moment(b.restoredTime);
    //   return st.diff(en);
    // },
    render: (restoredTime) => {
      if (restoredTime === null) {
        return <span>&nbsp;</span>;
      } else {
        return (
          <span>
            {/* <FormatDateTime text={restoredTime}></FormatDateTime> */}
          </span>
        );
      }
    },
  },
  {
    title: "Total Time",
    dataIndex: "total_time",
    key: "total_time",
    width: 180,
    sorter: (a, b) => {
      return null;
    },
  },
  {
    title: "SC Staff",
    dataIndex: "emp_name",
    key: "emp_name",
    width: 200,
    sorter: (a, b) => {
      return null;
    },
  },
  {
    title: "Status",
    dataIndex: "job_status_name",
    key: "job_status_name",
    width: 170,
    fixed: "right",
    sorter: (a, b) => {
      if (a.job_status_name && b.job_status_name) {
        return a.job_status_name.length - b.job_status_name.length;
      }
    },
  },
  //   {
  //     title: "Action",
  //     dataIndex: "",
  //     key: "",
  //     width: 150,
  //     fixed: "right",
  //     sorter: () => {
  //       return null;
  //     },
  //     render: (item) => {
  //       if (actionBtn.length > 0) {
  //         const btnFilter = actionBtn.filter(
  //           (data) =>
  //             data.job_type_id === item.job_type_id &&
  //             data.job_category_id === item.job_category_id &&
  //             data.from_main_process_id === item.job_status
  //         );
  //         return (
  //           <DynamicButton
  //             CompanyId={CompanyId}
  //             OperatorId={OperatorId}
  //             ProjectId={ProjectId}
  //             workflow={btnFilter}
  //             page={"ma_list"}
  //             wrapClassName={``}
  //             Jobdetail={item}
  //             language={factUpdate}
  //             factupdate={LangTranslate}
  //           />
  //         );
  //       }
  //     },
  //   },
];

const initRequest = {
  category_id: null,
  company_id: Cookies.get("companyid"),
  job_type_id: null,
  operator_id: Cookies.get("operator_id"),
  project_id: Cookies.get("project_id"),
  job_prority_id: null,
  username: Cookies.get("username"),
  job_sla_id: null,
  from_datetime: null,
  to_datetime: null,
  //area_code: null,
  area_code_list: null,
  search_text: null,
  MainProcessID: null,
  SubProcessID: null,
  owner_flag: false,
  jobStatus: null,
};

const JobHistory = () => {
  const authUserValue = useContext(authUserContext);
  const [data, setData] = useState([]);
  const [request, setRequest] = useState({
    ...initRequest,
    area_code_list: authUserValue.userArea,
  });
  const [jobCategory, setJobCategory] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [jobPriority, setJobPriority] = useState([]);
  const [jobSla, setJobSla] = useState([]);
  const [areaCodeList, setAreaCodeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  //   const jobCategory = useSelector((state) => state.metaData.jobCategory);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const getProjectId = () => {
    const keyProjectId = queryParams.get("projectId");
    if (keyProjectId !== null) {
      return keyProjectId === "" ? null : keyProjectId;
    } else {
      const filterProjectdata = JSON.parse(
        localStorage.getItem("projectData")
      ).filter((data) => {
        return data.operator_id == Cookies.get("operator_id");
      });
      return filterProjectdata[0]?.project_id;
    }
  };

  const Notify = (title, msg, type) => {
    const args = {
      message: title,
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    console.log("Notify", type, args);
    notification[type](args);
  };

  const getHistory = (request) => {
    setIsLoading(true);
    ServiceApi.post(
      "search_ma_history_list_job",
      { ...request, project_id: getProjectId() }
      // {
      //   category_id: null,
      //   company_id: "3",
      //   job_type_id: null,
      //   operator_id: "3",
      //   project_id: "5",
      //   job_prority_id: null,
      //   username: "user_bbtec",
      //   job_sla_id: null,
      //   from_datetime: null,
      //   to_datetime: null,
      //   area_code_list: [
      //     "AYA",
      //     "BK1",
      //     "BK2",
      //     "BK3",
      //     "BK4",
      //     "CBI",
      //     "CMI",
      //     "HYI",
      //     "KKN",
      //     "NMA",
      //     "PKT",
      //     "PLK",
      //     "RBI",
      //     "RYG",
      //     "SNI",
      //     "UBN",
      //     "UDN",
      //     "BMA",
      //   ],
      //   search_text: null,
      //   MainProcessID: null,
      //   SubProcessID: null,
      //   owner_flag: false,
      // }
    )
      .then(({ data: res }) => {
        // console.log("job_history", res);
        setIsLoading(false);
        if (res.result?.code === "P") {
          const filterData = res.data.result_ma_job_list.filter(
            (s) => s.job_status === 999 || s.job_status === 9
          );
          setData(filterData);
          //   getNextAction(job_cat_id);
          //setShouldRefresh(false);
        } else if (res.result?.code === "F") {
          Notify("Error", res.data.result?.showText, "error");
        }
      })
      .catch((error) => {
        Notify("Error", error.message ? error.message : error, "error");
      });
  };

  const getJobCategory = async () => {
    const { data: masterJobCategory } = await ServiceApi.post(
      "master_data/job_category_single",
      {
        company_id: initRequest.company_id,
        operator_id: initRequest.operator_id,
        project_id: initRequest.project_id,
      }
    );
    setJobCategory(masterJobCategory.data.result);
    const firstJobCategory =
      masterJobCategory.data.result.length === 0
        ? null
        : masterJobCategory.data.result[0]?.job_category_id;

    const { data: masterJobType } = await ServiceApi.post(
      "master_data/job_type_single",
      {
        pk_id: null,
        job_category_id: firstJobCategory,
        is_active: "1",
        effective: "1",
        sql_where: null,
        company_id: initRequest.company_id,
        operator_id: initRequest.operator_id,
        project_id: initRequest.project_id,
        UserName: Cookies.get("username"),
      }
    );

    // const firstJobType =
    //   masterJobType.data.result.length === 0
    //     ? null
    //     : masterJobType.data.result[0]?.job_type_id;

    setJobType(masterJobType.data.result);

    const { data: masterPriority } = await ServiceApi.post(
      "master_data/priority_single",
      {
        company_id: initRequest.company_id,
        operator_id: initRequest.operator_id,
        project_id: initRequest.project_id,
        job_category_id: null,
        job_type_id: null,
      }
    );

    setJobPriority(masterPriority.data.result);

    // const { data: masterSla } = await ServiceApi.post(
    //   "master_data/sla_single",
    //   {
    //     company_id: initRequest.company_id,
    //     operator_id: initRequest.operator_id,
    //     project_id: initRequest.project_id,
    //     job_category_id: firstJobCategory,
    //     job_type_id: firstJobType,
    //   }
    // );

    // setJobSla(masterSla.data.result);

    setRequest({
      ...request,
      category_id: firstJobCategory,
    });
    getHistory({ ...request, category_id: firstJobCategory });
    // console.log("masterSla", masterSla.data.result);
  };

  const getJobType = async (categoryId) => {
    getHistory({ ...request, category_id: categoryId });
    const { data: masterJobType } = await ServiceApi.post(
      "master_data/job_type_single",
      {
        pk_id: null,
        job_category_id: categoryId,
        is_active: "1",
        effective: "1",
        sql_where: null,
        company_id: initRequest.company_id,
        operator_id: initRequest.operator_id,
        project_id: initRequest.project_id,
        UserName: Cookies.get("username"),
      }
    );

    setJobType(masterJobType.data.result);

    console.log("masterJobType", masterJobType.data.result);
  };

  const getJobSla = async (jobTypeId) => {
    getHistory({ ...request, job_type_id: jobTypeId });
    const { data: masterSla } = await ServiceApi.post(
      "master_data/sla_single",
      {
        company_id: initRequest.company_id,
        operator_id: initRequest.operator_id,
        project_id: initRequest.project_id,
        job_category_id: request.category_id,
        job_type_id: jobTypeId,
      }
    );

    setJobSla(masterSla.data.result);
  };

  const getAreaCode = async () => {
    const { data: masterAreaCode } = await ServiceApi.post(
      "master_data/work_area_center",
      {
        company_id: initRequest.company_id,
        is_active: "1",
        where: "",
      }
    );
    const areaList = masterAreaCode.data.result;
    setAreaCodeList([
      { value: null, label: "All Area Code" },
      ...areaList.map((item) => ({
        value: item.area_code,
        label: item.area_code,
      })),
    ]);
  };

  const onDatePicker = (dates, dateStrings) => {
    setRequest({
      ...request,
      from_datetime: dateStrings[0],
      to_datetime: dateStrings[1],
    });
    getHistory({
      ...request,
      from_datetime: dateStrings[0],
      to_datetime: dateStrings[1],
    });
    // console.log(dates);
    // setformDate(dateStrings[0]);
    // settoDate(dateStrings[1]);
    // setShouldRefresh(dates);
  };

  useEffect(() => {
    console.log("request", request);
  }, [request]);

  useEffect(() => {
    getJobCategory();
    getAreaCode();

    return () => {};
  }, []);
  return (
    <LayoutOperationJobHistory>
      <div className="wrapper-header-1">
        <div className="container-fluid">
          <div className="d-flex job-header">
            <div className="d-flex align-content-center flex-wrap mr-auto">
              <img
                src={ServiceApi.absoluteUrl("/icon/bbtec/header/MA-List.svg")}
                alt={"history"}
                title={"History"}
              />
              <h2>MA History</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper-body">
        <div className="container-fluid">
          <div className="align-content-md-start flex-wrap w-100">
            <div className="d-flex justify-content-start flex-wrap">
              <div className="col col-12 col-md-10 order-1 order-md-0">
                <div className="row wrapper-search-list">
                  <div className="col col-12 col-sm-6 col-md-3 col-lg-2">
                    <Select
                      placeholder="Job Category"
                      className="w-100"
                      value={request.category_id}
                      onChange={(value) => {
                        setRequest({
                          ...request,
                          category_id: value,
                          job_type_id: null,
                          job_sla_id: null,
                        });
                        getJobType(value);
                      }}
                    >
                      {jobCategory && jobCategory.length > 0 ? (
                        jobCategory.map((data, index) => (
                          <Option
                            name="JobCategory"
                            key={`option_filter_priority_job_malist_${index}`}
                            value={data.job_category_id}
                          >
                            <span className="default-thai-font">
                              {data.job_category_name}
                            </span>
                          </Option>
                        ))
                      ) : (
                        <Option disabled>
                          <span className="default-thai-font">ไม่พบข้อมูล</span>
                        </Option>
                      )}
                    </Select>
                  </div>
                  <div className="col col-12 col-sm-6 col-md-3 col-lg-2">
                    <Select
                      placeholder="Job Type"
                      className="w-100"
                      value={request.job_type_id}
                      onChange={(value) => {
                        setRequest({ ...request, job_type_id: value });
                        getJobSla(value);
                      }}
                    >
                      <Option value={null} name="jobType">
                        <span className="default-thai-font">All Job Type</span>
                      </Option>
                      {jobType && jobType.length > 0 ? (
                        jobType.map((data, index) => (
                          <Option
                            name="jobType"
                            key={`option_filter_job_type_malist_${index}`}
                            value={data.job_type_id}
                          >
                            <span className="default-thai-font">
                              {data.job_type_name}
                            </span>
                          </Option>
                        ))
                      ) : (
                        <Option disabled>
                          <span className="default-thai-font">ไม่พบข้อมูล</span>
                        </Option>
                      )}
                    </Select>
                  </div>
                  <div className="col col-12 col-sm-6 col-md-3 col-lg-2">
                    <Select
                      placeholder="Job Priority"
                      className="w-100"
                      value={request.job_prority_id}
                      onChange={(value) => {
                        setRequest({ ...request, job_prority_id: value });
                        getHistory({ ...request, job_prority_id: value });
                      }}
                    >
                      <Option name="Priority" value={null}>
                        <span className="default-thai-font">All Priority</span>
                      </Option>
                      {jobPriority && jobPriority.length > 0 ? (
                        jobPriority.map((data, index) => (
                          <Option
                            name="Priority"
                            key={`option_filter_priority_job_malist_${index}`}
                            value={data.priority_id}
                          >
                            <span className="default-thai-font">
                              {data.priority_name}
                            </span>
                          </Option>
                        ))
                      ) : (
                        <Option disabled>
                          <span className="default-thai-font">ไม่พบข้อมูล</span>
                        </Option>
                      )}
                    </Select>
                  </div>
                  <div className="col col-12 col-sm-6 col-md-3 col-lg-2">
                    <Select
                      placeholder="SLA Level"
                      className="w-100"
                      value={request.job_sla_id}
                      onChange={(value) => {
                        setRequest({ ...request, job_sla_id: value });
                        getHistory({ ...request, job_sla_id: value });
                      }}
                    >
                      <Option value={null} name="Slalevel">
                        <span className="default-thai-font">All SLA Level</span>
                      </Option>
                      {jobSla && jobSla.length > 0
                        ? jobSla.map((data, index) => (
                            <Option
                              name="Slalevel"
                              key={`option_filter_sla_level_malist_${index}`}
                              value={data.job_sla_id}
                            >
                              <span className="default-thai-font">
                                {data.sla_name}
                              </span>
                            </Option>
                          ))
                        : null}
                    </Select>
                  </div>
                  <div className="col col-12 col-sm-6 col-md-6 col-lg-4">
                    <RangePicker
                      showTime={{
                        hideDisabledOptions: true,
                        defaultValue: [
                          moment("00:00", "HH:mm"),
                          moment("23:59", "HH:mm"),
                        ],
                      }}
                      className="w-100"
                      onChange={onDatePicker}
                      format={"YYYY-MM-DD HH:mm"}
                    />
                  </div>
                  <div className="col col-12 col-sm-6 col-md-6 col-lg-6">
                    <Input.Search
                      placeholder="Search"
                      enterButton
                      allowClear
                      onChange={(e) => {
                        const { value } = e.target;
                        // console.log(value);
                        setRequest({ ...request, search_text: value });
                      }}
                      value={request.search_text}
                      onSearch={() => getHistory(request)}
                    />
                  </div>
                  <div className="col col-12 col-sm-6 col-md-6 col-lg-2">
                    <Select
                      placeholder="Show Owner Only"
                      className="w-100"
                      value={request.owner_flag}
                      onChange={(value) => {
                        setRequest({ ...request, search_text: value });
                        getHistory({ ...request, search_text: value });
                      }}
                    >
                      <Option name="showonlyOwner" value={false}>
                        <span className="default-thai-font">
                          แสดงงานทั้งหมด
                        </span>
                      </Option>
                      <Option name="showonlyOwner" value={true}>
                        <span className="default-thai-font">เฉพาะงานตนเอง</span>
                      </Option>
                    </Select>
                  </div>
                  <div className="col col-12 col-sm-6 col-md-6 col-lg-2">
                    {/* <Select
                placeholder="Select Area"
                mode="multiple"
                name="areaCode"
                className="w-100"
                value={selectAreaCode}
                onChange={selectMultipleChange}
                onDropdownVisibleChange={onDropdownVisibleChange}
              >
                <Option
                  key="areaCode_Option_List_"
                  name="areaCode"
                  value={null}
                >
                  <span className="default-thai-font">All Area Code</span>
                </Option>
                {areaCodeList?.map((s, i) => (
                  <Option
                    key={`areaCode_Option_List_${i}`}
                    name="areaCode"
                    value={s.value}
                  >
                    <span className="default-thai-font">{s.label}</span>
                  </Option>
                ))}
              </Select> */}
                    <Select
                      mode="multiple"
                      placeholder="Select"
                      className="w-100 ant-select-ellipsis"
                      value={request.area_code_list}
                      onChange={(value) => {
                        // console.log("value", value);
                        let areaList = [null];
                        if (
                          value?.length > 0 &&
                          value[value.length - 1] !== null
                        ) {
                          areaList = value.filter((s) => s !== null);
                          // setRequest({
                          //   ...request,
                          //   area_code_list: value.filter((s) => s !== null),
                          // });
                          //   setselectAreaCode(value.filter((s) => s !== null));
                        }

                        setRequest({
                          ...request,
                          area_code_list: areaList,
                        });
                        getHistory({
                          ...request,
                          area_code_list: areaList,
                        });
                      }}
                      maxTagCount={"responsive"}
                    >
                      {areaCodeList?.map((s, i) => (
                        <Option key={`multiOption_${i}`} value={s?.value}>
                          <span className="default-thai-font">{s?.label}</span>
                        </Option>
                      ))}
                    </Select>
                  </div>
                  <div className="col col-12 col-sm-6 col-md-6 col-lg-2">
                    <Select
                      placeholder="Select Job Status"
                      //mode="multiple"
                      className="w-100"
                      value={request.jobStatus}
                      onChange={(value) => {
                        // let proress = {
                        //   MainProcessID: null,
                        //   SubProcessID: null,
                        // };
                        // switch (value) {
                        //   case 9:
                        //     proress = {
                        //       MainProcessID: 9,
                        //       SubProcessID: -1,
                        //     };
                        //     break;
                        //   case 999:
                        //     proress = {
                        //       MainProcessID: 999,
                        //       SubProcessID: -1,
                        //     };
                        //     break;

                        //   default:
                        //     break;
                        // }
                        setRequest({
                          ...request,
                          jobStatus: value,
                          MainProcessID: value,
                          SubProcessID: -1,
                        });
                        getHistory({
                          ...request,
                          jobStatus: value,
                          MainProcessID: value,
                          SubProcessID: -1,
                        });
                      }}
                      //   showSearch
                    >
                      <Option name="jobStatus" value={null}>
                        <span className="default-thai-font">
                          All Job Status
                        </span>
                      </Option>
                      <Option name="showonlyOwner" value={9}>
                        <span className="default-thai-font">Cancel</span>
                      </Option>
                      <Option name="showonlyOwner" value={999}>
                        <span className="default-thai-font">Completed</span>
                      </Option>
                      {/* {wfProcesslist && wfProcesslist.length > 0
                        ? genOption()
                        : null} */}
                      {/* {wfProcesslist && wfProcesslist.length > 0
                  ? wfProcesslist.map((s, i) => (
                      <Option
                        name="jobStatus"
                        key={`wfProcessList_Option_index${i}`}
                        value={`${s.mainProcessID}_${s.subProcessID}`}
                      >
                        <span className="default-thai-font">
                          {s.process_desc}
                        </span>
                      </Option>
                    ))
                  : null} */}
                    </Select>
                  </div>
                </div>
              </div>
              {/* <div className="col col-12 col-md-2 order-0 order-md-1 ml-auto">
                <div className="d-flex align-items-end align-content-center flex-column">
                  <div className="p-2">
                    {workflow && workflow.length > 0
                      ? workflow.map((data, index) => {
                          if (data.next_main_action_id === 15) {
                            return (
                              <Renderbtn
                                key={`filter_btn_index_${index}`}
                                renderBtn={{
                                  visible: true,
                                  html_tag: "button",
                                  type: "ImagewithText",
                                  icon_align: "left",
                                  text: `Add Job`,
                                  image_path: "/icon/add_job.svg",
                                  css: "btn btn-xs btn-primary",
                                }}
                                btnMiddleware={openAddJob}
                                index="view_btn_addjob"
                                item={{ linkto: "/addjob" }}
                                disable={false}
                              ></Renderbtn>
                            );
                          }
                        })
                      : null}
                  </div>
                </div>
              </div> */}
            </div>
            {isLoading ? (
              <Skeleton height={320} />
            ) : (
              <Table
                columns={columns}
                className={css(TableCss)}
                rowKey="job_id"
                dataSource={data}
                agination={{ pageSize: 10 }}
                scroll={{ x: 1200 }}
                showSorterTooltip={false}
              />
            )}
          </div>
        </div>
      </div>
    </LayoutOperationJobHistory>
  );
};

export default JobHistory;
